export const MAX_SMALL_DEVICE_WIDTH = 551;
export const LARGE_DEVICE_WIDTH = 992;
export const MEDIUM_DEVICE_WIDTH = 770;
export const MAX_MEDIUM_DEVICE_WIDTH = 1200;
